import React from 'react';
import { SectionCTA } from '../SectionCTA';
const KARITO_PHOTO = 'https://cdn.magicpatterns.com/patterns/generated-images/96c18f3c-0e11-49a7-a518-70ca4bf061f0.jpg';
export function About() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-60" data-mp="12r6r8vseijfr">
      <div className="mx-auto w-full max-w-3xl" data-id="element-61" data-mp="12okk2x9fa5y2">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-62" data-mp="yqd1rxzb8wkr">
          About <span className="italic text-gold-dark" data-id="element-63" data-mp="b08xrpi7mut8">Dr. Karito</span>
        </h2>

        <div className="mt-8 grid grid-cols-1 items-center gap-6 sm:grid-cols-[minmax(0,240px)_1fr]" data-id="element-64" data-mp="61p9vjk238y8">
          <img src={KARITO_PHOTO} alt="Portrait of Dr. Karito in her dental clinic" className="mx-auto w-full max-w-[260px] rounded-3xl border border-gold/25 object-cover shadow-[0_20px_50px_-24px_rgba(14,21,38,0.5)]" loading="lazy" data-id="element-65" data-mp="jt2qaomo3qp1" />
          <div className="text-center sm:text-left" data-id="element-66" data-mp="3jehlok9sexf2">
            <p className="text-[15px] leading-relaxed text-ink-soft" data-id="element-67" data-mp="3jdpxvvmfm3zc">
              This protocol was built inside real clinics—not classrooms.
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-68" data-mp="3870edkes6jfm">
              It comes from years of real cases, real mistakes, and the need for a system that
              actually works under pressure.
            </p>
            <p className="mt-4 rounded-2xl bg-sand/70 p-4 text-[15px] font-semibold leading-relaxed text-ink" data-id="element-69" data-mp="3hzz63b5kqq3g">
              The mission is simple: give dentists clarity, confidence, and control in complex
              cases.
            </p>
          </div>
        </div>

        <SectionCTA headline="Apply the same clinical criteria in your own practice." data-id="element-70" data-mp="2u6z5pis9y7pl" />
      </div>
    </section>;
}